import { createSlice } from '@reduxjs/toolkit';
// import { database } from 'faker/locale/en_AU';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  clients: null,
  cadences: null,
  createdClient: null,
  detailInfo: null,
  updateClient: null,
  clientTokens: null,
  createTokens: null,
  deleteTokens: null,
  updateTokens: null,
  clientIntegrationsEx: null,
  postBacks: null,
  createIntegrationsEx: null,
  deleteIntegrationsEx: null,
  updateIntegrationsEx: null,
  columns: null,
  data: null,
  leadSearchData: null,
  saveLeadData: null,
  fieldMappings:[],
  authenticationTypes:[],
  sendTypes:[],
  endPointTypes: [],
  lqclientproductlist:[],
  lqsaidlist:[],
  cadencenames:[],
  clientExceptions:[],
  bookings: [],
  digitalConversions: [],
  dataLayoutCategories: [],
  dataExportDataTypes: [],
  dataExportBoolTypes: [],
  dataExportReplaceTypes: [],
  dataExportTimestampTypes: [],
  leadDisposition: [],
  qualifierLeadStates: [],
  dataexportFilterTypes: [],
  channels: [],
  DataexportJobFomatTypes: [],
  DataexportJobDestinationTypes: [],
  DataexportJobFileChunkingTypes: [],
  DataexportJobLogStatus: {},
  DataexportJobFrequencyTypes: [],
  payloadTypes: {},
  postbackTiggerTypes: {}
};

const slice = createSlice({
  name: 'subaccount',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    formatError(state, action) {
      state.error = false;
    },
    getClient(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },
    //GET BOOKING LIST
    getBookingList(state, action) {
      state.isLoading = false;
      state.bookings = action.payload;
    },
    getDigitalConversionList(state, action) {
      state.isLoading = false;
      state.digitalConversions = action.payload;
    },
    // GET PROFILE
    getClientIntegration(state, action) {
      state.isLoading = false;
      state.clients = action.payload;
    },
    getCadenceNames(state, action) {
      state.isLoading = false;
      state.cadencenames = action.payload;
    },

    //CREACT CLIENTINTEGRATION ACCOUNT
    createClientIntegration(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },

    // TODO - finalize
    createClient(state, action) {
      state.isLoading = false;
      state.createdClient = action.payload;
    },
    updateClientTokens(state, action) {
      state.isLoading = false;
      state.updateTokens = action.payload;
    },

    createClientTokens(state, action) {
      state.isLoading = false;
      state.createTokens = action.payload;
    },

    deleteClientTokens(state, action) {
      state.isLoading = false;
      state.deleteTokens = action.payload;
    },

    updateClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.updateIntegrationsEx = action.payload;
    },

    createClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.createIntegrationsEx = action.payload;
    },

    deleteClientIntegrationsEx(state, action) {
      state.isLoading = false;
      state.deleteIntegrationsEx = action.payload;
    },

    getDetailInfo(state, action) {
      state.isLoading = false;
      state.detailInfo = action.payload;
    },

    // TODO - Finalize
    updateClient(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    updateClientIntegration(state, action) {
      state.isLoading = false;
      state.updateClient = action.payload;
    },

    getClientTokens (state, action) {
      state.isLoading = false;
      state.clientTokens = action.payload;
    },

    getClientIntegrationsEx (state, action) {
      state.isLoading = false;
      state.clientIntegrationsEx = action.payload;
    },

    getPostBacks (state, action) {
      state.isLoading = false;
      state.postBacks = action.payload;
    },
    getSubAccount (state, action){
      state.isLoading = false;
      state.subAccountData = action.payload;
    },
    getDataLayoutCategories (state, action){
      state.isLoading = false;
      state.dataLayoutCategories = action.payload;
    },
    dataExportDataType (state, action){
      state.isLoading = false;
      state.dataExportDataTypes = action.payload;
    },
    dataexportTimestampTypes (state, action){
      state.isLoading = false;
      state.dataExportTimestampTypes = action.payload;
    },
    dataexportReplaceTypes (state, action){
      state.isLoading = false;
      state.dataExportReplaceTypes = action.payload;
    },
    dataexportBoolTypes (state, action){
      state.isLoading = false;
      state.dataExportBoolTypes = action.payload;
    },
    getLeadDisposition (state, action){
      state.isLoading = false;
      state.leadDisposition = action.payload;
    },
    getQualifierLeadStates (state, action){
      state.isLoading = false;
      state.qualifierLeadStates = action.payload;
    },
    getDataexportFilterTypes (state, action){
      state.isLoading = false;
      state.dataexportFilterTypes = action.payload;
    },
    getChannels (state, action){
      state.isLoading = false;
      state.channels = action.payload;
    },
    getPayloadTypes (state, action){
      state.isLoading = false;
      state.payloadTypes = action.payload;
    },
    getPostbackTriggerTypes (state, action){
      state.isLoading = false;
      state.postbackTiggerTypes = action.payload;
    },
    getDataexportJobformatTypes (state, action){
      state.isLoading = false;
      state.DataexportJobFomatTypes = action.payload;
    },
    getDataexportJobFrequencyTypes (state, action){
      state.isLoading = false;
      state.DataexportJobFrequencyTypes = action.payload;
    },
    getDataexportJobDestinationTypes (state, action){
      state.isLoading = false;
      state.DataexportJobDestinationTypes = action.payload;
    },
    getDataexportFileChunkingTypes (state, action){
      state.isLoading = false;
      state.DataexportJobFileChunkingTypes = action.payload;
    },
    getDataexportJobLogStatus (state, action){
      state.isLoading = false;
      state.DataexportJobLogStatus = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow } = slice.actions;


export function updateClientIntegrations(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/update_client_with_integration', data);
      dispatch(slice.actions.updateClientIntegration(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function formatUpdateClientIntegrations(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientIntegration(null));
  };
}

// ----------------------------------------------------------------------

export function createTokens(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/create_client_token', data);
      dispatch(slice.actions.createClientTokens(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteTokens(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/delete_client_token', data);
      dispatch(slice.actions.deleteClientTokens(response.data));
      
      
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      
      
      return false;
    }
  };
}

export function createIntegrationsEx(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      if (!data.is_active)  {
        data.is_active = 0;
      }
      const response = await axios.post('/iapi/create_client_integration', data);
      dispatch(slice.actions.createClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function deleteIntegrationsEx(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/delete_client_integration', data);
      dispatch(slice.actions.deleteClientIntegrationsEx(response.data));
      
      
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      
      
      return false;
    }
  };
}

export function deletePostBack(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/postBack/delete', data);
      // dispatch(slice.actions.deleteClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      
      
      return false;
    }
  };
}

export function formatClientTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientTokens(null));
  };
}

export function formatDeleteClientTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.deleteClientTokens(null));
  };
}

export function formatClientIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.createClientIntegrationsEx(null));
  };
}

export function formatDeleteClientIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.deleteClientIntegrationsEx(null));
  };
}

// ----------------------------------------------------------------------

export function updateClientTokens(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/update_client_token', data);
      dispatch(slice.actions.updateClientTokens(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function formatUpdateTokens() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientTokens(null));
  };
}

export function updateClientIntegrationsEx(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/update_client_integration', data);
      dispatch(slice.actions.updateClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return false
    }
  };
}

export function formatUpdateIntegrationsEx() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.updateClientIntegrationsEx(null));
  };
}


// ----------------------------------------------------------------------

export function getDetailInfo(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getdetail', {id: id});
      dispatch(slice.actions.getDetailInfo(response.data));
      return response.data
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getCallCadenceList(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/cadences/show/'+id);
      dispatch(slice.actions.getCadenceNames(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getLqCadencesList(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get('/iapi/clients/cadences/'+id);
      return response.data
    } catch (error) {
      return []
    }
  };
}

export function getBookingList(client_integration_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/getBookingList', {client_integration_id});
      dispatch(slice.actions.getBookingList(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getDigitalConversionList(client_integration_id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/getDigitalConversionList', {client_integration_id});
      dispatch(slice.actions.getDigitalConversionList(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCallCadenceList(id,data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/cadences/update/'+id, {cadences:JSON.stringify(data)});
      dispatch(slice.actions.getCadenceNames(response.data));
      return response.data
    } catch (error) {
      return []
    }
  };
}
export function formatDetailInfo() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.getDetailInfo(null));
    dispatch(slice.actions.getClientTokens(null));
    dispatch(slice.actions.getClientIntegrationsEx(null));
    dispatch(slice.actions.getPostBacks(null));
  };
}

// ----------------------------------------------------------------------
export function getSubAccount(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/iapi/get_client_integrations?client_id=${id}`);
      dispatch(slice.actions.getSubAccount(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getClientIntegrationsEx(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      
      
      const response = await axios.post('/iapi/get_client_integrations', {client_id: id});
      dispatch(slice.actions.getClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostBacks(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      
      
      const response = await axios.get(`/iapi/postBack/${id}`);
      dispatch(slice.actions.getClientIntegrationsEx(response.data));
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPostBackById(clietnId, postBackId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/iapi/postBack/getpostback/${clietnId}/${postBackId}`);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getClientIntegrationEx(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/get_client_integration', {id: id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
// ----------------------------------------------------------------------

export function setRouterConfiguration(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/setRouterConfiguration', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getThrottleSchedule(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/iapi/leadthrottle/getThrottleSchedule/${id}`);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setThrottleSchedule(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadthrottle/setThrottleSchedule', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getLeadRouter(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/getLeadRouter', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getEventsApi(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/getEventsApi', {client_integration_id: id});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getInboundTypes() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/iapi/eventsApi/getInboundTypes');
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getConfigureEvents(inboundId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/getConfigureEvents', {api_inbound_id: inboundId});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function removeError() {
  return async (dispatch) => {
    dispatch(slice.actions.formatError());
  };
}

export function deleteConfigureEvents(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/deleteConfigureEvents', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function saveConfigureEvents(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/saveConfigureEvents', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function setEventStatusData(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/setEventsApiStatus', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function setSaveEventsApi(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/eventsApi/setSaveEventsApi', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getRouterVersions(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/getRouterVersions', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setRouterStatus(data) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/leadRouter/setRouterStatus', data);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPublishedVersions(id, is_version=0) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/iapi/getPublishedVersions', {id: id, is_version});
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getDataexportVirtualFields() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/api/dataExport/virtualFields');
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataExports(client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/dataExport/list', { client_integration_id });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataExportJobs(client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/dataExport/dataexportJob/list', { client_integration_id });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

export function createDataLayout(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/dataExport/create', data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataLayoutCategories() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/api/dataExport/data_categories');
      dispatch(slice.actions.getDataLayoutCategories(response.data));
    } catch (error) {
      console.log(error);
    }
  };
}

export function dataExportDataType() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/api/dataExport/dataExport_types');
      dispatch(slice.actions.dataExportDataType(response.data));
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataexportTimestampTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/api/dataExport/dataexport_timestamp_types');
      dispatch(slice.actions.dataexportTimestampTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataexportReplaceTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/api/dataExport/dataexport_replace_types');
      dispatch(slice.actions.dataexportReplaceTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataexportBoolTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get('/api/dataExport/dataexport_bool_types');
      dispatch(slice.actions.dataexportBoolTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataLayoutFieldNames(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/dataExport/get_list_by_Code', data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  };
}

export function createDataField(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/dataExport/create_data_field', data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  };
}

export function filterCheckUncheckAll(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/dataExport/filter_check_uncheck_all', data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  };
}

export function getDataExportById(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/dataExport/${id}`);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataExportJobById(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/dataexportJob/${id}`);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataExportJobLogs(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/exportjob_logs/${id}`);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function updateDataLayoutOrder(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/update_datalayout_order`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function updateReplacementsOrder(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/update_replacement_order`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function removeDataLayout(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/remove_dataLayout`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function removeDataexport(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/remove_dataexport`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function changeDataLayoutStatus(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/change_datalayout_status`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function removeDataexportJob(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/remove_dataexport_job`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function pauseDataexportJob(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/pause_active_dataexport_job`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function exportjobRunOnetime(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/onetimerun`, {jobid: id});
      return response.data
    } catch (error) {
      return error
    }
  }; 
}

export function createDataexportReplacementRule(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/create_dataexport_replacement_rule`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function removeReplacementRule(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/remove_replacement_rule`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getLeadDisposition() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/lead_disposition`);
      dispatch(slice.actions.getLeadDisposition(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getQualifierLeadStates() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/qualifier_lead_States`);
      dispatch(slice.actions.getQualifierLeadStates(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataexportFilterTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/dataexport_filter_types`);
      dispatch(slice.actions.getDataexportFilterTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getChannels() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/channels`);
      dispatch(slice.actions.getChannels(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataexportJobformatTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/fomat_types`);
      dispatch(slice.actions.getDataexportJobformatTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataexportJobFrequencyTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/frequency_types`);
      dispatch(slice.actions.getDataexportJobFrequencyTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataexportJobDestinationTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/destination_types`);
      dispatch(slice.actions.getDataexportJobDestinationTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function updateDataexportFilter(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/update_dataexport_filter`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function saveDataexportLayout(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/save_dataexport_layout`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function saveDataexportJob(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/dataexportJob/save`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataexportFileChunkingTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/file_Chunking_types`);
      dispatch(slice.actions.getDataexportFileChunkingTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getDataexportJobLogStatus() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/api/dataExport/exportjob_log_status`);
      dispatch(slice.actions.getDataexportJobLogStatus(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}
export function primaryTimestampValiable(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/primary_timestamp_valiable`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function testDestinationbyData(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/test_destination`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getSampleReport(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/api/dataExport/get_sample_report`, data);
      return response.data
    } catch (error) {
      console.log(error);
      return null;
    }
  }; 
}

// postback

export function savePostbackPayload(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/postback/payload_save', data);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

export function getPostbackPayload(client_integration_id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/postback/playload_list', { client_integration_id });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
}

export function removePostabackPayload(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/payload_remove`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getPostbackPayloadById(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/iapi/postback/payload/${id}`);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getPayloadTypes(client_endpoint_ids = null) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/payload_types`, {client_endpoint_ids : client_endpoint_ids});
      dispatch(slice.actions.getPayloadTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getPayloadFieldNamesByCode(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/postback/get_payload_field_name_by_Code', data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  };
}

export function createPayloadField(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/postback/create_data_field', data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  };
}

export function removePayloadField(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/payload_field_remove`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function updatePostbackPayloadOrder(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/update_payload_order`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function createPostbackReplacementRule(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/create_postback_replacement_rule`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function removePostbackReplacementRule(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/remove_postback_replacement_rule`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function updatePostbackReplacementsOrder(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/update_postback_replacement_order`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function savePostbackDb(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/save_postback`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getPostbackTriggerTypes() {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/iapi/postback/trigger_types`);
      dispatch(slice.actions.getPostbackTriggerTypes(response.data));
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function savePostbackTrigger(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/trigger_save`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getPostbackTriggerById(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/iapi/postback/trigger/${id}`);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function getPostbackTriggers(id) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`/iapi/postback/triggers/${id}`);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function testAuthenticationbyData(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/test_connection`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function removePostbackTrigger(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/remove_trigger`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function pausePostbackTrigger(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/pause_active_trigger`, {id});
      return response.data
    } catch (error) {
      console.log(error);
    }
  }; 
}

export function coppyPostbackTrigger(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`/iapi/postback/copy_trigger`, data);
      return response.data
    } catch (error) {
      console.log(error);
    }
  };
}

export function copyPostbackPayload(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/postback/copy_payload', data);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
}

export function toggleTriggerTestMode(id) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/postback/toggle_test_mode', { id });
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
}

export function getPostbackTestLogs(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/iapi/postback/get_test_logs', data);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
}
